import React from 'react';

export default function ThirdBottomStaticRow({ data, borderClasses }) {
    return (
        <section className='flex flex-row gap-5'>
            <article className='flex flex-col gap-y-2 w-3/4'>
                <h1 className='w-full font-bold text-center'>Repair Order History</h1>
                <section className='w-full border overflow-auto max-h-[400px]'>
                    <table className='relative w-full'>
                        <thead className='sticky top-0 text-white bg-blue-primary'>
                            <tr className='text-center'>
                                <th className='border-r-[1px] border-white pl-4'>Vendor</th>
                                <th className={borderClasses}>Unit Cost</th>
                                <th className={borderClasses}>Estimated Cost</th>
                                <th className={borderClasses}>EXP DEL</th>
                                <th className={borderClasses}>CC</th>
                                <th className={borderClasses}>EXP CC</th>
                                <th className={borderClasses}>QREP</th>
                                <th className={borderClasses}>QSHPD</th>
                                <th className={borderClasses}>QRECD</th>
                                <th className='px-1'>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.repairOrderHistory?.map((data) => {
                                return (
                                    <tr className='border-b last:!border-none'>
                                        <td className='py-3 pl-4'>
                                            <h1
                                                className={
                                                    ' ' + (data?.highlighted && 'bg-yellow-300 bg-opacity-40 p-1 w-fit')
                                                }
                                            >
                                                {data.vendorName}
                                            </h1>
                                        </td>
                                        <td className='px-1'>
                                            {data.unitRepairCost?.toLocaleString('en-US', {
                                                style: 'currency',
                                                currency: 'USD',
                                            })}
                                        </td>
                                        <td className='px-1'>
                                            {data.estimatedRepairCost
                                                ? data.estimatedRepairCost?.toLocaleString('en-US', {
                                                      style: 'currency',
                                                      currency: 'USD',
                                                  })
                                                : ''}
                                        </td>
                                        <td className='px-1 text-center'>{data.expectedDeliveryDate}</td>
                                        <td className='px-1 text-center'>{data.conditionCode}</td>
                                        <td className='px-1 text-center'>{data.expectedConditionCode}</td>
                                        <td className='px-1 text-center'>{data.quantityToRepair}</td>
                                        <td className='px-1 text-center'>{data.quantityShipped}</td>
                                        <td className='px-1 text-center'>{data.quantityReceived}</td>
                                        <td className='px-1'>{data.createdDate}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
            </article>
            <article className='flex flex-col gap-y-2 w-1/4'>
                <h1 className='w-full font-bold text-center'>Customer Exchanges History</h1>
                <section className='w-full border overflow-auto max-h-[400px]'>
                    <table className='relative w-full'>
                        <thead className='sticky top-0 text-white bg-blue-primary'>
                            <tr className='text-center'>
                                <th className='border-r-[1px] border-white pl-4'>Customer Name</th>
                                <th className={borderClasses}>SO#</th>
                                <th className={borderClasses}>Date</th>
                                <th className={borderClasses}>CC</th>
                                <th className={borderClasses}>SN</th>
                                <th className='px-1'>Core DT</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.customerExchangeHistory?.map((data) => {
                                return (
                                    <tr className='border-b last:!border-none'>
                                        <td className='py-3 pl-4'>
                                            <h1
                                                className={
                                                    ' ' + (data?.highlighted && 'bg-yellow-300 bg-opacity-40 p-1 w-fit')
                                                }
                                            >
                                                {data.customerName}
                                            </h1>
                                        </td>
                                        <td className='px-1'>{data.salesOrder}</td>
                                        <td className='px-1'>{data.createdDate}</td>
                                        <td className='px-1'>{data.conditionCode}</td>
                                        <td className='px-1'>{data.serialNumber}</td>
                                        <td className='px-1'>{data.coreDT}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
            </article>
        </section>
    );
}
